import { render, staticRenderFns } from "./link-group.vue?vue&type=template&id=46695f31&scoped=true&"
import script from "./link-group.vue?vue&type=script&lang=js&"
export * from "./link-group.vue?vue&type=script&lang=js&"
import style0 from "./link-group.vue?vue&type=style&index=0&id=46695f31&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46695f31",
  null
  
)

export default component.exports